// Normal theme TOP FRAME only. Inert until controlled native GA4 cutoff.
(()=>{
(function installStorefrontGa4OwnerV2(w, { cutoverEnabled = false } = {}) {
  const ID = "G-X0FZPLRQ56", SOURCE = "mojokoe_ga4_storefront_v2", LIMIT = 256;
  if (!cutoverEnabled) return { active: false, reason: "PREPARED_NOT_CUT_OVER" };
  if (w.__mojokoeGa4StorefrontOwnerV2) return w.__mojokoeGa4StorefrontOwnerV2;
  if (w.__mojokoeGa4StorefrontOwnerV1?.active) return { active: false, reason: "V1_OWNER_ALREADY_ACTIVE" };
  if (String(w.Shopify?.theme?.id) !== "188352266531") return { active: false, reason: "THEME_NOT_REVIEWED" };
  const disable = "ga-disable-" + ID;
  w[disable] = true;
  const state = { active: true, configured: false, queued: 0, reads: 0, skipped: 0, reason: "PERMISSION_NOT_READ" };
  const viewedVariants = new Set(), noticedDrawers = new WeakSet(), drawerRevisions = new WeakMap();
  let privacyRevision = 0, configured = false, pageSent = false, cartPageSent = false;
  let baseline = null, readTicket = 0, baselineLoading = false;
  const allowed = () => {
    try {
      const api = w.Shopify?.customerPrivacy, raw = api?.currentVisitorConsent?.();
      return !!raw && (raw.analytics === "yes" || raw.analytics === "") && api.analyticsProcessingAllowed() === true;
    } catch { return false; }
  };
  const currentPage = () => {
    let url;
    try { url = new URL(w.location.href); } catch { return null; }
    if (url.protocol !== "https:" || url.port || url.username || url.password ||
        !["mojokoe.com", "www.mojokoe.com", "111vc6-hh.myshopify.com"].includes(url.hostname)) return null;
    let segments;
    try { segments = url.pathname.split("/").filter(Boolean).map(decodeURIComponent); } catch { return null; }
    if (segments.some(part => /^(?:checkouts?|orders?)$/.test(part))) return null;
    // Account paths are a fixed copy; no customer IDs. Other encoded paths are skipped.
    const account = segments.includes("account"), path = account ? "/account" : url.pathname;
    if (!/^\/[A-Za-z0-9/_~.+-]*$/.test(path) || path.length > 2048) return null;
    return { location: url.origin + path, product: segments.includes("products"), cart: segments.at(-1) === "cart" };
  };
  const variantId = value => {
    if (typeof value === "number" && !Number.isSafeInteger(value)) return null;
    const text = String(value ?? "");
    return /^[1-9]\d{0,19}$/.test(text) ? "gid://shopify/ProductVariant/" + text : null;
  };
  const cartSnapshot = raw => {
    if (!raw || !Array.isArray(raw.items) || raw.items.length > 200) return null;
    const quantities = new Map();
    for (const line of raw.items) {
      const id = variantId(line?.variant_id), quantity = line?.quantity;
      if (!id || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 10000) return null;
      const total = (quantities.get(id) ?? 0) + quantity;
      if (total > 10000) return null;
      quantities.set(id, total);
    }
    return quantities;
  };
  const items = snapshot => [...snapshot].map(([item_id, quantity]) => ({ item_id, quantity }));
  const sameCart = (a,b) => a.size === b.size && [...a].every(([id,quantity]) => b.get(id) === quantity);
  function configure(page) {
    if (configured) return true;
    if (w.dataLayer && typeof w.dataLayer.push !== "function") { state.reason = "GOOGLE_QUEUE_UNAVAILABLE"; return false; }
    w.dataLayer = w.dataLayer || [];
    w.gtag = typeof w.gtag === "function" ? w.gtag : function () { w.dataLayer.push(arguments); };
    if (![...w.document.querySelectorAll("script[src]")].some(s => /^https:\/\/www\.googletagmanager\.com\/gtag\/js(?:\?|$)/.test(s.src))) {
      const script = w.document.createElement("script"); script.async = true;
      script.src = "https://www.googletagmanager.com/gtag/js?id=" + ID;
      w.document.head.appendChild(script); w.gtag("js", new Date());
    }
    // Merchant GA4 collection controls, not a mutation/claim of visitor Ads consent.
    w.gtag("config", ID, { send_page_view: false, allow_google_signals: false,
      allow_ad_personalization_signals: false, page_location: page.location, page_referrer: "" });
    configured = true; state.configured = true; return true;
  }
  function send(name, eventItems) {
    if (!allowed()) { w[disable] = true; state.skipped++; state.reason = "ANALYTICS_NOT_ALLOWED"; return false; }
    const page = currentPage();
    if (!page || w.document.visibilityState === "hidden" || state.queued >= LIMIT) {
      state.skipped++; state.reason = !page ? "PAGE_NOT_OWNED" : "HIDDEN_OR_DOCUMENT_EVENT_LIMIT"; return false;
    }
    if (!["page_view", "view_item", "add_to_cart", "remove_from_cart", "view_cart"].includes(name) ||
        name !== "page_view" && (!Array.isArray(eventItems) || !eventItems.length)) return false;
    w[disable] = false; if (!configure(page)) return false;
    if (!allowed()) { w[disable] = true; return false; }
    const parameters = { send_to: ID, page_location: page.location, page_referrer: "", mjk_funnel_source: SOURCE };
    if (eventItems) parameters.items = eventItems;
    w.gtag("event", name, parameters); state.queued++; state.reason = "SCOPED_EVENT_QUEUED_NOT_RECEIPT";
    return true;
  }
  function productView(value) {
    if (!currentPage()?.product) return;
    const id = variantId(value);
    if (!id || viewedVariants.has(id) || viewedVariants.size >= LIMIT) return;
    if (send("view_item", [{ item_id: id, quantity: 1 }])) viewedVariants.add(id);
  }
  function initialProduct() {
    // Exact main-product form prefix exists in the reviewed Prestige HTML.
    const input = w.document.querySelector('main form[id^="product-form-main-"] [name="id"]');
    if (input) productView(input.value);
  }
  function cartView(snapshot) {
    const eventItems = items(snapshot);
    if (eventItems.length) return send("view_cart", eventItems);
    return false; // Empty cart is not a fabricated ecommerce item.
  }
  async function readCart({ pageView = false, drawer = null, drawerRevision = 0, changeSnapshot = null, baseEvent = "" } = {}) {
    if (!allowed() || !currentPage()) return;
    const ticket = ++readTicket, privacy = privacyRevision, previous = baseline;
    let root = w.Shopify?.routes?.root;
    if (typeof root !== "string" || !/^\/(?:[a-zA-Z]{2}(?:-[a-zA-Z]{2})?\/)?$/.test(root)) return;
    const url = new URL(root + "cart.js", w.location.origin);
    if (url.origin !== w.location.origin || url.search || url.hash) return;
    state.reads++;
    try {
      const response = await w.fetch(url.href, { method: "GET", credentials: "same-origin", redirect: "error",
        cache: "no-store", headers: { Accept: "application/json" } });
      if (!response.ok || !allowed() || privacy !== privacyRevision || ticket !== readTicket) return;
      const raw = await response.json();
      if (!allowed() || privacy !== privacyRevision || ticket !== readTicket) return;
      const snapshot = cartSnapshot(raw);
      if (!snapshot) { baseline = null; return; }
      baseline = snapshot;
      // Native quantity requests may overlap. Never infer a delta from a stale response.
      if (changeSnapshot && previous) {
        if (!sameCart(changeSnapshot,snapshot)) { state.reason = "STALE_NATIVE_CART_HELD_AND_RESYNCED"; return; }
        const added = [], removed = [];
        for (const id of new Set([...previous.keys(), ...snapshot.keys()])) {
          const delta = (snapshot.get(id) ?? 0) - (previous.get(id) ?? 0);
          if (delta > 0) added.push({ item_id: id, quantity: delta });
          if (delta < 0) removed.push({ item_id: id, quantity: -delta });
        }
        if (removed.length && baseEvent === "variant:add") { state.reason = "AMBIGUOUS_ADD_CART_SNAPSHOT_HELD"; return; }
        if (added.length) send("add_to_cart", added);
        if (removed.length) send("remove_from_cart", removed);
      }
      if (pageView && currentPage()?.cart && !cartPageSent) cartPageSent = cartView(snapshot);
      if (drawer && drawer.hasAttribute("open") && drawerRevisions.get(drawer) === drawerRevision) cartView(snapshot);
    } catch { state.reason = "CART_READ_FAILED_CLOSED"; }
  }
  function refresh() {
    const permission = allowed(), page = currentPage();
    w[disable] = !permission || !page;
    if (!permission || !page) { baseline = null; readTicket++; baselineLoading = false; state.reason = "ANALYTICS_NOT_ALLOWED_OR_PAGE_NOT_OWNED"; return; }
    if (!pageSent) pageSent = send("page_view");
    initialProduct();
    if (!baseline && !baselineLoading) {
      baselineLoading = true;
      readCart({ pageView: page.cart }).finally(() => { baselineLoading = false; });
    }
  }
  w.document.addEventListener("visitorConsentCollected", () => { privacyRevision++; refresh(); });
  w.document.addEventListener("variant:change", event => {
    // A form control named id can mask form.id; use the actual form attribute.
    if (!allowed() || event.target?.localName !== "form" ||
        !String(event.target.getAttribute("id") ?? "").startsWith("product-form-main-")) return;
    productView(event.detail?.variant?.id);
  });
  w.document.addEventListener("cart:change", event => {
    if (!allowed() || !currentPage()) { baseline = null; readTicket++; return; }
    readTicket++; // Never let an older pending GET overwrite the successful native event.
    const next = cartSnapshot(event.detail?.cart), baseEvent = event.detail?.baseEvent;
    if (!next) { baseline = null; return; }
    if (["variant:add", "line-item:change", "quick-order-list:add"].includes(baseEvent)) readCart({ changeSnapshot: next, baseEvent });
  });
  // These dialog events do not bubble in the reviewed theme. Capture observes the real open transition.
  w.document.addEventListener("dialog:after-show", event => {
    const drawer = event.target;
    if (!allowed() || drawer?.localName !== "cart-drawer" || !drawer.hasAttribute("open") || noticedDrawers.has(drawer)) return;
    noticedDrawers.add(drawer);
    const revision = (drawerRevisions.get(drawer) ?? 0) + 1; drawerRevisions.set(drawer, revision);
    readCart({ drawer, drawerRevision: revision });
  }, true);
  w.document.addEventListener("dialog:after-hide", event => {
    const drawer = event.target;
    if (drawer?.localName !== "cart-drawer") return;
    noticedDrawers.delete(drawer); drawerRevisions.set(drawer, (drawerRevisions.get(drawer) ?? 0) + 1);
  }, true);
  w.document.addEventListener("visibilitychange", refresh);
  if (w.document.readyState === "loading") w.document.addEventListener("DOMContentLoaded", refresh, { once: true });
  else refresh();
  if (!w.Shopify?.customerPrivacy?.analyticsProcessingAllowed && typeof w.Shopify?.loadFeatures === "function") {
    w.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => { if (!error) refresh(); });
  }
  state.refresh = refresh;
  w.__mojokoeGa4StorefrontOwnerV2 = state;
  return state;
})(window,{cutoverEnabled:false});
})();
